// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: wheel_app/wheel_app.proto

/* eslint-disable */
import type { User } from "../common/users";

export interface Wheel {
  id: string;
  hasCustomPrizes: boolean;
  createdAt: string | undefined;
  updatedAt: string | undefined;
}

export interface Spin {
  id: string;
  wheelId: string;
  user: User | undefined;
  prize: Prize | undefined;
  status: Spin_SpinStatus;
  createdAt: string | undefined;
  updatedAt: string | undefined;
}

export const Spin_SpinStatus = {
  UNKNOWN_SPIN_STATUS: "UNKNOWN_SPIN_STATUS",
  WON: "WON",
  LOST: "LOST",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Spin_SpinStatus = typeof Spin_SpinStatus[keyof typeof Spin_SpinStatus];

export namespace Spin_SpinStatus {
  export type UNKNOWN_SPIN_STATUS = typeof Spin_SpinStatus.UNKNOWN_SPIN_STATUS;
  export type WON = typeof Spin_SpinStatus.WON;
  export type LOST = typeof Spin_SpinStatus.LOST;
  export type UNRECOGNIZED = typeof Spin_SpinStatus.UNRECOGNIZED;
}

export interface Prize {
  id: string;
  name: string;
  imageUrl?: string | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  testingIgnore?: string | undefined;
}
